<template>
<div v-if="show">
  <div class="pagination-wrapper">
    <div class="pagination">
      <div v-for="(dot, index) in dots" :key="index">
        <span :class="{ active: visitedItems.includes(index) }" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'pagination',
  data () {
    return {
      show: false,
      dots: [],
      visitedItems: []
    }
  },
  props: ['numberOfDots', 'numberOfVisitedDots'],
  methods: {
    addDots () {
      for (let i = 0; i < parseInt(this.numberOfDots); i++) {
        this.dots.push(this.dots.length + 1)
      }
    },
    addVisitedItems (i) {
      this.visitedItems.push(i)
    }
  },
  beforeMount () {
    this.addDots()
    for (let indx = 0; indx < parseInt(this.numberOfVisitedDots); indx++) {
      this.addVisitedItems(indx)
    }
  },
  computed: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.pagination-wrapper {
  width: 100%;
  height: 100%;
  background: transparent;
}
.pagination {
  position: relative;
  left: 40%;
  top: 40%;
}
.pagination span {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.pagination span.active {
  background: #069ccc;
  width: 14px;
  height: 14px;
  top: 0;
  right: 3px;
  margin-left: 6px;
}
.pagination span:before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  background: inherit;
  border: 2px solid #069ccc;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue